"use strict";
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/util/isDate.js
// module id = ./node_modules/rxjs/util/isDate.js
// module chunks = 0